// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Currency from "../../../../../../library/data-source/country-currency/Currency.bs.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as PaymentModeType from "../entity/PaymentModeType.bs.js";
import * as OrderFareApiModel from "../api-model/OrderFareApiModel.bs.js";
import * as OrderFareErrorType from "../entity/OrderFareErrorType.bs.js";
import * as DeccoUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.bs.js";

function decodeFareBreakupDetails(breakup, underpayment_sop_status) {
  return {
          partner_trip_fare: Currency.toCurrency(breakup.partner_trip_fare),
          porter_bearing_total_discount: Currency.toCurrency(breakup.porter_bearing_total_discount),
          trip_fare: Currency.toCurrency(breakup.trip_fare),
          pre_trip_fare_round_off: Belt_Option.mapWithDefault(breakup.pre_trip_fare_round_off, undefined, (function (v) {
                  return Caml_option.some(Currency.toCurrency(v));
                })),
          base_fare: Currency.toCurrency(breakup.base_fare),
          distance_charge: Currency.toCurrency(breakup.distance_charge),
          travel_duration_charge: Currency.toCurrency(breakup.travel_duration_charge),
          waiting_charge: Currency.toCurrency(breakup.waiting_charge),
          flat_surge_amount: Currency.toCurrency(breakup.flat_surge_amount),
          toll: Currency.toCurrency(breakup.toll),
          vat: Belt_Option.mapWithDefault(breakup.vat, undefined, (function (v) {
                  return Caml_option.some(Currency.toCurrency(v));
                })),
          road_tax: Currency.toCurrency(breakup.road_tax),
          convenience_charge: Currency.toCurrency(breakup.convenience_charge),
          environmental_tax: Currency.toCurrency(breakup.environmental_tax),
          toll_breakup_details: List.map((function (t) {
                  return {
                          title: t.title,
                          amount: Currency.toCurrency(t.amount)
                        };
                }), breakup.toll_breakup_details),
          referral_discount: Currency.toCurrency(breakup.referral_discount),
          coupon_discount: Currency.toCurrency(breakup.coupon_discount),
          rewards_discount: Currency.toCurrency(Belt_Option.getWithDefault(breakup.rewards_discount, 0)),
          subscription_discount: Currency.toCurrency(breakup.subscription_discount),
          credit_charge: Currency.toCurrency(breakup.credit_charge),
          helper_charge: Currency.toCurrency(breakup.helper_charge),
          helper_plus_labour_charge: Currency.toCurrency(breakup.helper_plus_labour_charge),
          waypoint_charge: Currency.toCurrency(breakup.waypoint_charge),
          tax_on_commission: Currency.toCurrency(breakup.tax_on_commission),
          cgst_on_commission: Currency.toCurrency(breakup.cgst_on_commission),
          sgst_on_commission: Currency.toCurrency(breakup.sgst_on_commission),
          igst_on_commission: Currency.toCurrency(breakup.igst_on_commission),
          pickup_extra_charge: Belt_Option.mapWithDefault(breakup.pickup_extra_charge, undefined, (function (v) {
                  return Caml_option.some(Currency.toCurrency(v));
                })),
          drop_extra_charge: Belt_Option.mapWithDefault(breakup.drop_extra_charge, undefined, (function (v) {
                  return Caml_option.some(Currency.toCurrency(v));
                })),
          waiting_time: breakup.waiting_time,
          courier_fee: Belt_Option.mapWithDefault(breakup.courier_fee, undefined, (function (v) {
                  return Caml_option.some(Currency.toCurrency(v));
                })),
          underpayment_sop_status: underpayment_sop_status
        };
}

function decodeVehicleFareVersion(fare) {
  return {
          id: fare.id,
          free_waiting_mins: fare.free_waiting_mins,
          travel_rate_per_min: List.map((function (p) {
                  return {
                          lower_km: p.lower_km,
                          upper_km: p.upper_km,
                          price_per_km: Currency.toCurrency(p.price_per_km),
                          price_per_min: Currency.toCurrency(p.price_per_min)
                        };
                }), fare.travel_rate_per_min),
          capacity: fare.capacity,
          size: fare.size
        };
}

function decodeFare(fare, underpayment_sop_status) {
  return {
          amount: Currency.toCurrency(fare.amount),
          breakup_details: decodeFareBreakupDetails(fare.breakup_details, underpayment_sop_status),
          previous_due: Currency.toCurrency(fare.previous_due),
          order_fare_error: OrderFareErrorType.fromString(fare.order_fare_error),
          vehicle_fare_version: decodeVehicleFareVersion(fare.vehicle_fare_version),
          is_manually_adjusted_fare: fare.is_manually_adjusted_fare
        };
}

function decodeFareDetails(fare_details, underpayment_sop_status) {
  return {
          customer: Belt_Option.mapWithDefault(fare_details.customer, undefined, (function (f) {
                  return decodeFare(f, underpayment_sop_status);
                })),
          estimated: decodeFare(fare_details.estimated, underpayment_sop_status)
        };
}

function decodePaymentDetails(payment) {
  return {
          breakup: {
            driver_collected_cash: {
              amount: Currency.toCurrency(payment.breakup_details.driver_collected_cash.amount)
            },
            actual_driver_collected_cash: {
              amount: Currency.toCurrency(payment.breakup_details.actual_driver_collected_cash.amount)
            },
            cashback: {
              amount: Currency.toCurrency(payment.breakup_details.cashback.amount)
            },
            porter_credits: {
              amount: Currency.toCurrency(payment.breakup_details.porter_credits.amount)
            },
            paytm: {
              amount: Currency.toCurrency(payment.breakup_details.paytm.amount)
            },
            instamojo: {
              amount: Currency.toCurrency(payment.breakup_details.instamojo.amount)
            },
            razorpay: {
              amount: Currency.toCurrency(payment.breakup_details.razorpay.amount)
            },
            business_account: {
              amount: Currency.toCurrency(payment.breakup_details.business_account.amount)
            },
            muneemji: {
              amount: Currency.toCurrency(payment.breakup_details.muneemji.amount)
            }
          },
          summary: {
            total_payment: {
              amount: Currency.toCurrency(payment.summary_details.total_payment.amount)
            },
            fare_payable: {
              amount: Currency.toCurrency(payment.summary_details.fare_payable.amount)
            }
          }
        };
}

function execute(json) {
  var order_fare = DeccoUtils$Catalyst.resolveResult(OrderFareApiModel.t_decode(json), "OrderFareEntityMapper.re");
  return {
          fare_details: decodeFareDetails(order_fare.order_fares.fare_details, order_fare.order_fares.underpayment_sop_status),
          payment_break_up_details: Belt_Option.mapWithDefault(order_fare.order_fares.payment_break_up_details, undefined, (function (p) {
                  return decodePaymentDetails(p);
                })),
          payment_mode: PaymentModeType.fromString(order_fare.order_fares.payment_mode)
        };
}

export {
  execute ,
  
}
/* DeccoUtils-Catalyst Not a pure module */
